import { createContext, useContext } from "react";

// The two Commander sub-projects. Each owns its own routes, stores and API
// base URL, namespaced under /swageazy/* and /swayy/* respectively. Auth and
// generic UI components are shared across both.
export type Workspace = "swageazy" | "swayy";

export const WORKSPACES: { id: Workspace; label: string; basename: string }[] =
  [
    { id: "swageazy", label: "Swageazy", basename: "/swageazy" },
    { id: "swayy", label: "Swayy", basename: "/swayy" },
  ];

export const DEFAULT_WORKSPACE: Workspace = "swageazy";

// Determines which workspace a raw browser pathname belongs to. Anything
// that isn't unambiguously under /swayy falls back to swageazy.
export const resolveWorkspace = (pathname: string): Workspace => {
  const swayy = WORKSPACES.find((w) => w.id === "swayy")!;
  if (
    pathname === swayy.basename ||
    pathname.startsWith(`${swayy.basename}/`)
  ) {
    return "swayy";
  }
  return DEFAULT_WORKSPACE;
};

export const basenameForWorkspace = (workspace: Workspace): string =>
  WORKSPACES.find((w) => w.id === workspace)!.basename;

const WorkspaceContext = createContext<Workspace>(DEFAULT_WORKSPACE);

export const WorkspaceProvider = WorkspaceContext.Provider;

export const useActiveWorkspace = (): Workspace => useContext(WorkspaceContext);

// Full page reload by design: switching workspaces must discard every
// project-scoped store instance rather than carry stale state across.
export const switchWorkspace = (workspace: Workspace) => {
  window.location.href = basenameForWorkspace(workspace);
};
